import { render, staticRenderFns } from "./StoreError.vue?vue&type=template&id=6c89b1ac&"
import script from "./StoreError.vue?vue&type=script&lang=js&"
export * from "./StoreError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c89b1ac')) {
      api.createRecord('6c89b1ac', component.options)
    } else {
      api.reload('6c89b1ac', component.options)
    }
    module.hot.accept("./StoreError.vue?vue&type=template&id=6c89b1ac&", function () {
      api.rerender('6c89b1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/StoreError.vue"
export default component.exports